import React, { useEffect, useState, useRef } from 'react';
import qs from 'qs';
import { PropTypes } from 'prop-types';
import SearchBox from './components/SearchBox';
import Tabs from './components/Tabs';
import AdvancedSearch from './components/AdvancedSearch';

const AdvancedSearchMain = ({
  placeholder,
  initialAdvancedSearchData,
  tabsActive,
  isModal,
  searchId,
}) => {
  const mainSearchData = JSON.parse(initialAdvancedSearchData);
  const tabsData = mainSearchData.map(tab => {
    if (tab.tabLabel && tab.tabValue) {
      const obj = { label: tab.tabLabel, value: tab.tabValue };
      return obj;
    }
    return [];
  });
  const isFirstLoad = useRef(true);
  const [query, setQuery] = useState();
  const [tabs, setTabs] = useState(tabsData);
  const [selectedTab, setSelectedTab] = useState(tabs[0]);

  const cleanQueryString = () => {
    const url = new URL(window.location.href);
    url.search = '';
    window.history.replaceState({}, '', url);
  };

  useEffect(() => {
    const qsParams = qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    });
    if (isFirstLoad.current && qsParams.tab) {
      isFirstLoad.current = false;
      cleanQueryString();
    }
  }, []);

  return (
    <>
      <SearchBox placeholder={placeholder} query={query} setQuery={setQuery} />
      {tabsActive && tabs && tabs.length && query && query.length >= 3 ? (
        <Tabs
          tabs={tabs}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
      ) : (
        ''
      )}
      {mainSearchData && mainSearchData.length
        ? mainSearchData.map((search, index) =>
            search.tabValue === selectedTab.value ? (
              <div key={index}>
                <AdvancedSearch
                  advancedIndex={index}
                  query={query}
                  setQuery={setQuery}
                  mainSearchData={mainSearchData}
                  selectedTab={selectedTab}
                  setSelectedTab={setSelectedTab}
                  setTabs={setTabs}
                  tabs={tabs}
                  tabsData={tabsData}
                  isModal={isModal}
                  cleanQueryString={cleanQueryString}
                  searchId={searchId}
                  isTabsLoaded={isFirstLoad}
                />
              </div>
            ) : (
              ''
            )
          )
        : ''}
    </>
  );
};

AdvancedSearchMain.propTypes = {
  placeholder: PropTypes.string.isRequired,
  initialAdvancedSearchData: PropTypes.string.isRequired,
  tabsActive: PropTypes.string.isRequired,
  isModal: PropTypes.string,
  searchId: PropTypes.string.isRequired
};

export default AdvancedSearchMain;
